<template>
	<div class="animated fadeIn">

		<b-row>
			<b-col sm="12">

				<b-card header="Your Profile">

					<b-alert v-bind:show=this.showSuccess variant="success">Password changed successfully.</b-alert>
					<b-alert v-bind:show=this.showAlert variant="danger">Change password failed. Please check your password and try again.</b-alert>
					<b-alert v-bind:show=this.invalidPassword variant="danger">Password must have at least 6 characters.</b-alert>
					<b-alert v-bind:show=this.invalidRepeatPassword variant="danger">Password and repeat password must be identical.</b-alert>

					<b-row>
						<b-col md="6">
							<b-form-group
								label="Email:"
								label-for="emailInput"
								:label-cols="3"
								:horizontal="true">
								<b-form-input plaintext id="emailInput" type="text" v-bind:value="this.email"></b-form-input>
							</b-form-group>
							<b-form-group
								label="Name:"
								label-for="nameInput"
								:label-cols="3"
								:horizontal="true">
								<b-form-input plaintext id="nameInput" type="text" v-bind:value="this.name"></b-form-input>
							</b-form-group>
							<b-form-group
								label="Role:"
								label-for="roleInput"
								:label-cols="3"
								:horizontal="true">
								<b-form-input plaintext id="roleInput" type="text" v-bind:value="this.role"></b-form-input>
							</b-form-group>
							<b-form-group
								label="Password:"
								label-for="passwordInput"
								:label-cols="3"
								:horizontal="true">
								<b-form-input plaintext id="passwordInput" type="text" value="******"></b-form-input>
							</b-form-group>
							<b-form-group
								label="Old Password:"
								label-for="oldPasswordInput"
								:label-cols="3"
								:horizontal="true">
								<b-form-input id="oldPasswordInput" type="password" autocomplete="old-password" v-bind:disabled=this.disableInputs v-model="oldPassword"></b-form-input>
							</b-form-group>
							<b-form-group
								label="New Password:"
								label-for="newPasswordInput"
								:label-cols="3"
								:horizontal="true">
								<b-form-input id="newPasswordInput" type="password" autocomplete="new-password" v-bind:disabled=this.disableInputs v-model="newPassword"></b-form-input>
							</b-form-group>
							<b-form-group
								label="Repeat Password:"
								label-for="repeatPasswordInput"
								:label-cols="3"
								:horizontal="true">
								<b-form-input id="repeatPasswordInput" type="password" autocomplete="repeat-password" v-bind:disabled=this.disableInputs v-model="repeatPassword"></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>

					<br>

                    <b-button variant="primary" v-bind:disabled=this.disableInputs v-on:click="saveClicked">Save</b-button>
                    <b-button variant="link" v-bind:disabled=this.disableInputs v-on:click="cancelClicked">Cancel</b-button>
					<br><br>

				</b-card>

			</b-col>
		</b-row>
	</div>

</template>



<script>

import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js'
import {poolData} from '@/shared/aws-settings'

export default {
	name: 'profile',

	data: () => {
		return {
			email: "",
			oldPassword: "",
			newPassword: "",
			repeatPassword: "",
			name: "",
			role: "",
			showSuccess: false,
			showAlert: false,
			invalidPassword: false,
			invalidRepeatPassword: false,
			disableInputs: false,
			currentCognitoUser: null

		}
	},

	/*
	mounted() {

	},

    updated() {

	},
	*/
	
	created() {
		var userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
		var cognitoUser = userPool.getCurrentUser();
		var vueInstance = this;
		this.currentCognitoUser = cognitoUser;

		if (cognitoUser != null) {
			cognitoUser.getSession(function(err, session) {
				if (session.isValid()) {
					cognitoUser.getUserAttributes(function(err, result) {
						if (err) {
							//alert(err);
							return;
						}
						for (var i = 0; i < result.length; i++) {
							if (result[i].getName() == "email")
								vueInstance.email = result[i].getValue();
							else if (result[i].getName() == "name")
								vueInstance.name = result[i].getValue();
							else if (result[i].getName() == "custom:role")
								vueInstance.role = result[i].getValue();
						}
					});
				}

			});
		}

	},

	methods: {
        cancelClicked: function (event) {
			event.target.blur();
			this.oldPassword = "";
			this.newPassword = "";
			this.repeatPassword = "";
			this.showSuccess = false;
			this.showAlert = false;
			this.invalidPassword = false;
			this.invalidRepeatPassword = false;

        },

        saveClicked: function (event) {
            event.target.blur();

			this.disableInputs = true;
			this.showSuccess = false;
			this.showAlert = false;
			this.invalidPassword = false;
			this.invalidRepeatPassword = false;

			var vueInstance	= this;
      
			if (this.newPassword.length < 6)
				this.invalidPassword = true;
			if (this.newPassword != this.repeatPassword)
				this.invalidRepeatPassword = true;

			if (!this.invalidPassword && !this.invalidRepeatPassword) {

				if (this.currentCognitoUser != null) {
					this.currentCognitoUser.getSession(function(err, session) {
						if (session.isValid()) {

							vueInstance.currentCognitoUser.changePassword(vueInstance.oldPassword, vueInstance.newPassword, function(err, result) {
								if (err) {
									//alert(err);
									vueInstance.showAlert = true;
									vueInstance.disableInputs = false;
									return;
								}

								vueInstance.oldPassword = "";
								vueInstance.newPassword = "";
								vueInstance.repeatPassword = "";
								vueInstance.showSuccess = true;
								vueInstance.disableInputs = false;
							});

						}
						else {
							vueInstance.showAlert = true;
							vueInstance.disableInputs = false;
						}

					});
				}
				else {
					vueInstance.showAlert = true;
					vueInstance.disableInputs = false;
				}
			}
			else
				this.disableInputs = false;


        }

	}

}
</script>



<style>

</style>
